import updateSelected from './updateSelected';

const updateDocumentTypes = (state, payload) => {
  const docTypes = updateSelected(payload, state.documentTypes);
  return docTypes;
};

export default updateDocumentTypes;
